document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;

  const updateShippingHelp = () => {
    const summaries = [...root.querySelectorAll('.puffy-product__accordion summary')];
    const shippingSummary = summaries.find(summary => {
      const label = (summary.textContent || '').trim().toLowerCase();
      return label === 'shipping & returns' || label === 'shipping & after-sales';
    });
    const shippingDetails = shippingSummary?.closest('.puffy-product__accordion');
    const content = shippingDetails?.querySelector('.puffy-product__accordion-content');
    if (!shippingSummary || !content) return false;

    shippingSummary.innerHTML = 'Shipping &amp; After-Sales';
    content.innerHTML = '<p>Questions about shipping, delivery, cancellations, tracking, or after-sales support? <a href="/pages/faqs">Visit Help &amp; FAQs →</a></p>';

    root.querySelector('.puffy-product__help-link')?.remove();
    return true;
  };

  if (updateShippingHelp()) return;
  const observer = new MutationObserver(() => {
    if (updateShippingHelp()) observer.disconnect();
  });
  observer.observe(root, { childList: true, subtree: true });
});
